<template>
  <div class="content">
    <div class="rsk-px-xl rsk-pt-m">
      <div class="rsk-flex rsk-mb-m">
        <div class="rsk-mr-m rsk-width-180">
          <div class="rsk-mb-s rsk-pie-chart-tip">
            <div id="rsk-pie-chart" class="rsk-pie-chart" :class="{ 'rsk-pie-chart--over50': isChartOver }">
              <div class="rsk-pie-chart__progress">
                <div class="rsk-pie-chart__progress-fill" :style="{ transform: 'rotate(' + chartOverDeg + 'deg)' }"></div>
              </div>
              <div class="rsk-pie-chart__percents">
                <div class="rsk-pie-chart__percents-wrapper">
                  <div class="rsk-pie-chart__percents-text">ToDo</div>
                  <div class="rsk-pie-chart__percents-value">{{ info.studyElgPercen != 0 ? info.studyElgPercen : '-' }}%
                  </div>
                </div>
                <label class="rsk-tooltip rsk-tooltip--250 rsk-tooltip--left"
                  style="height:fit-content;top:50%;left:100%;transform:translateY(-50%);width:300px">
                  <span>ToDoの「％」表示について：ボックス・自社研修・自身で申込した研修は対象外です。</span>
                </label>
              </div>
            </div>
          </div>
          <div class="rsk-modal" v-if="onboardingModalFlag === 0 && showModal" style="display:flex; align-items:center; justify-content:center;">
             <div class="rsk-modal__content" style="max-width:600px; margin:auto;position:relative;">
                <span class="rsk-icon rsk-icon--close-gray080"
                   style="position:absolute; top:16px; right:16px; width:24px; height:24px; cursor:pointer;"
                   onclick="this.closest('.rsk-modal').style.display='none';">
                </span>
                <div class="rsk-modal__inner" style="padding:40px 30px; display:flex; flex-direction:column; align-items:center;text-align:center;">
                   <p class="rsk-text-blue" style="font-weight:bold;margin:0 0 16px 0;">この体験が、与信教育のスタートになります</p>
                   <p style="margin:0 0 4px 0;">サイバックスUniv.では</p>
                   <p style="margin:0 0 4px 0;">与信管理に関する知識を体系的に学ぶことが出来ます</p>
                   <p style="margin:0 0 12px 0;">ではさっそく学習を始めましょう</p>
                   <p class="rsk-text-blue" style="margin:0 0 8px 0;font-size:11px;">＼ まずはやってみよう／</p>
                   <button class="rsk-button rsk-button--large rsk-button--user-primary" style="font-size:14px;margin:0 0 16px 0;" @click="startMiniTest">
                   ミニ模擬テストで腕試し
                   </button>
                   <p style="margin:0 0 12px 0;"><a class="rsk-link-hover-darken" href="#" @click="moveToMngUsrNew" style="text-decoration: underline;font-size:11px;">社員のユーザー登録を行う（無料）</a></p>
                   <label class="rsk-checkbox-container">
                   <input type="checkbox" name='rm9FirstUseFlag' class="rsk-checkbox" v-model="versions[0].dontShow" @change="handleChange(0)"/>
                   <span class="rsk-checkbox__image"></span>
                   <span class="rsk-checkbox__label" style="font-size:11px;">今後表示しない</span>
                   </label>
                </div>
             </div>
          </div>
          <div class="rsk-modal" v-if="onboardingModalFlag === 1 && showModal" style="display:flex; align-items:center; justify-content:center;">
             <div class="rsk-modal__content" style="max-width:600px; margin:auto;position:relative;">
                <span class="rsk-icon rsk-icon--close-gray080"
                   style="position:absolute; top:16px; right:16px; width:24px; height:24px; cursor:pointer;"
                   onclick="this.closest('.rsk-modal').style.display='none';">
                </span>
                <div class="rsk-modal__inner" style="padding:40px 30px; display:flex; flex-direction:column; align-items:center;text-align:center;">
                   <p class="rsk-text-blue" style="font-weight:bold;margin:0 0 16px 0;">社内の与信知識力はどれくらいありますか？</p>
                   <p style="margin:0 0 4px 0;">社員のユーザー登録を完了すると</p>
                   <p style="margin:0 0 16px 0;">模擬テストや与信入門講座などをすぐに受講できます</p>
                   <p style="margin:0 0 4px 0;">取引時のリスクを回避するために</p>
                   <p style="margin:0 0 12px 0;">学習環境を整えましょう！</p>
                   <p class="rsk-text-blue" style="margin:0 0 8px 0;font-size:11px;">＼ 何人でも、無料で利用できます ／</p>
                   <button class="rsk-button rsk-button--large rsk-button--user-primary" style="font-size:14px;margin:0 0 16px 0;" @click="moveToMngUsrNew">
                   社員のユーザー登録を行う
                   </button>
                   <p style="margin:0 0 12px 0;"><a class="rsk-link-hover-darken" href="#" @click="moveToMngUsrCsv" style="text-decoration: underline;font-size:11px;">ユーザー登録を一括で行う（無料）</a></p>
                   <label class="rsk-checkbox-container">
                   <input type="checkbox" name='rm9SingleRegFlag' class="rsk-checkbox" v-model="versions[1].dontShow" @change="handleChange(1)"/>
                   <span class="rsk-checkbox__image"></span>
                   <span class="rsk-checkbox__label" style="font-size:11px;">今後表示しない</span>
                   </label>
                </div>
             </div>
          </div>
          <div class="rsk-modal" v-if="onboardingModalFlag === 2 && showModal" style="display:flex; align-items:center; justify-content:center;">
             <div class="rsk-modal__content" style="max-width:600px; margin:auto;position:relative;">
                <span class="rsk-icon rsk-icon--close-gray080"
                   style="position:absolute; top:16px; right:16px; width:24px; height:24px; cursor:pointer;"
                   onclick="this.closest('.rsk-modal').style.display='none';">
                </span>
                <div class="rsk-modal__inner" style="padding:40px 30px; display:flex; flex-direction:column; align-items:center;text-align:center;">
                   <p class="rsk-text-blue" style="font-weight:bold;margin:0 0 16px 0;">与信の知識を組織に浸透させましょう</p>
                   <p style="margin:0 0 4px 0;">与信判断の質を高めるチャンスです</p>
                   <p style="margin:0 0 12px 0;">組織全体で貸倒れや倒産リスクを防ぎましょう</p>
                   <p class="rsk-text-blue" style="margin:0 0 8px 0;font-size:11px;">＼ 何人でも、無料で利用できます ／</p>
                   <button class="rsk-button rsk-button--exlarge rsk-button--user-primary" style="font-size:14px;margin:0 0 16px 0;"  @click="moveToMngUsrCsv">
                   社員まとめてユーザー登録を行う
                   </button>
                   <p style="margin:0 0 12px 0;"><a class="rsk-link-hover-darken" href="#" @click="moveToMngUsrNew" style="text-decoration: underline;font-size:11px;">社員一人ずつユーザー登録を行う（無料）</a></p>
                   <label class="rsk-checkbox-container">
                   <input type="checkbox" name='rm9BulkRegFlag' class="rsk-checkbox" v-model="versions[2].dontShow" @change="handleChange(2)"/>
                   <span class="rsk-checkbox__image"></span>
                   <span class="rsk-checkbox__label" style="font-size:11px;">今後表示しない</span>
                   </label>
                </div>
             </div>
          </div>
          <div class="rsk-flex rsk-justify-between rsk-mb-s" v-if="info.displayFlg7 != studyTimeUnShowFlag">
            <div class="rsk-text-gray100 rsk-width-180" style="display: flex; align-items: center; flex-wrap: wrap;">
              <div>
                <span class="rsk-font-size-xs">{{ learnTimeTitle }}</span>
                <span class="rsk-font-size-xs">{{ info.learningTimeShow }}</span>
              </div>
              <span class="rsk-icon rsk-icon--question-gray-s" style="width: 16px; height: 16px;margin-left: 4px;">
                <label class="rsk-tooltip rsk-tooltip--250 rsk-tooltip--left"
                  style="height:fit-content;top:50%;left:180%;transform:translateY(-50%);width:281px">
                  <span>
                    {{ learnTimeTooilp }}
                  </span>
                </label>
              </span>
            </div>
          </div>
          <div class="rsk-divider rsk-divider--horizontal rsk-mb-s"></div>
          <div class="rsk-font-size-xs rsk-text-gray080">{{ $t("usrTopPages.loginId") }}</div>
          <div class="rsk-text-gray100 rsk-mb-s">{{ info.loginId }}</div>
          <div class="rsk-font-size-xs rsk-text-gray080">{{ $t("usrTopPages.mailaddr") }}</div>
          <div class="rsk-text-gray100 rsk-mb-s rsk-word-break">{{ info.usrMlAdr }}</div>
          <div class="rsk-font-size-xs rsk-text-gray080">{{ $t("usrTopPages.adminUsrTopLoginBefEntDtm") }}</div>
          <div class="rsk-text-gray100 rsk-mb-s">{{ info.loginBefEntDtm }}</div>
          <div class="rsk-divider rsk-divider--horizontal rsk-mb-s"></div>
          <a href="javascript:void(0);" @click="moveToUsrPro()"
            class="rsk-hover-underline rsk-text-primary rsk-flex rsk-items-center">
            <span class="rsk-button__icon-wrapper rsk-button__icon-wrapper--with-text">
              <span class="rsk-icon rsk-icon--edit-primary"></span>
            </span>
            {{ $t("usrTopPages.adminUsrTopProDel") }}
          </a>
        </div>

        <div class="rsk-flex-grow-1" v-if="useFlag">
          <span class="text-prompt">管理者の設定により、「利用停止」の状態になっています。研修利用ご希望の場合、管理者にお問い合わせください。<br>
          ※「利用停止」時には、お知らせ・ヘルプ・アカウント管理のみ利用できます。
          </span>
        </div>
        <div class="rsk-flex-grow-1" v-if="!useFlag">
          <rsk-panel :title="$t('usrTopPages.adminTopInfTitle')" v-if="displayFlg5 ? info.infList.length > 0 : false"
            :items="info.infList" @select="informationSelect">
          </rsk-panel>

          <div class="rsk-flex rsk-justify-between" v-if="(info.bpfElgList.length > 0 ) && !useFlag">
            <div class="rsk-flex only-here">
                <span class="management-title">
                  {{ $t("usrTopPages.adminTopBusinessTitle") }}
                   <rsk-title-bar :title="$t('usrTopPages.adminTopEnrollTitle')" />
                </span>
            </div>
          </div>
          <rsk-panel-list v-if="info.bpfElgList.length > 0 && !useFlag" :goWhere="'bpf'" :list="info.bpfElgList" :displayFlg2="displayFlg2" />
          <div v-if="info.bpfElgList.length > 0 && !useFlag && displayFlg2" class="rsk-align-right rsk-mb-s">
            <a href="javascript:void(0);" @click="moveToPageByPath('/elgstudy')"
               class="rsk-display_inline-flex rsk-text-primary rsk-flex rsk-items-center rsk-hover-underline">
              {{ $t("usrTopPages.adminTopAllElgPageToolip") }}
              <span class="rsk-button__icon-wrapper rsk-button__icon-wrapper--with-text">
                <span class="rsk-icon rsk-icon--carret-right-user"></span>
              </span>
            </a>
          </div>

          <div class="rsk-flex rsk-justify-between" v-if="(info.rmElgBenchmarkList.length > 0 ) && !useFlag">
            <div class="rsk-flex only-here">
                <span class="management-title">
                  {{ $t("usrTopPages.adminTopKnowledgeTitle") }}
                   <rsk-title-bar :title="$t('usrTopPages.adminTopTestTitle')" />
                </span>
            </div>
          </div>
          <rsk-panel-list ref="benPanelListRef" v-if="info.rmElgBenchmarkList.length > 0 && !useFlag" :goWhere="'ben'" :list="info.rmElgBenchmarkList" :displayFlg2="displayFlg2" />

          <div class="rsk-flex rsk-justify-between" v-if="(info.rmElgOnboardingList.length > 0 ) && !useFlag">
            <div class="rsk-flex only-here">
                <span class="management-title">
                  {{ $t("usrTopPages.adminTopLearnTitle") }}
                   <rsk-title-bar :title="$t('usrTopPages.adminTopEnrollTitle')" />
                </span>
            </div>
          </div>
          <rsk-panel-list v-if="info.rmElgOnboardingList.length > 0 && !useFlag" :goWhere="'onb'" :list="info.rmElgOnboardingList" :displayFlg2="displayFlg2" />
          <div v-if="info.rmElgOnboardingList.length > 0 && !useFlag && displayFlg2" class="rsk-align-right rsk-mb-s">
            <a href="javascript:void(0);" @click="moveToPageByPath('/elgstudy')"
               class="rsk-display_inline-flex rsk-text-primary rsk-flex rsk-items-center rsk-hover-underline">
              {{ $t("usrTopPages.adminTopAllElgPageToolip") }}
              <span class="rsk-button__icon-wrapper rsk-button__icon-wrapper--with-text">
                <span class="rsk-icon rsk-icon--carret-right-user"></span>
              </span>
            </a>
          </div>

          <rsk-title-bar :title="$t('usrTopPages.adminTopTodoListTilte')" v-if="!useFlag"
            :describe="processedDescribeText" @click="handleLinkClick"/>
          <div class="rsk-card rsk-mb-s"
            v-if="info.elgList.length <= 0 && info.tesList.length <= 0 && info.antList.length <= 0 && info.repList.length <= 0 && info.lesList.length <= 0 && !useFlag">
            <span>{{ $t("usrTopPages.adminTopTodoStudyTitle") }}</span>
          </div>
          <rsk-panel-list v-if="info.lesList.length > 0 && !useFlag" :goWhere="'les'" :list="info.lesList" />
          <div v-if="info.lesList.length > 0 && !useFlag" class="rsk-align-right rsk-mb-s">
            <a href="javascript:void(0);" @click="moveToPageByPath('/les')"
              class="rsk-display_inline-flex rsk-text-primary rsk-flex rsk-items-center rsk-hover-underline">
              {{ $t("usrTopPages.adminTopAllLesPageToolip") }}
              <span class="rsk-button__icon-wrapper rsk-button__icon-wrapper--with-text">
                <span class="rsk-icon rsk-icon--carret-right-user"></span>
              </span>
            </a>
          </div>

          <rsk-panel-list v-if="info.elgList.length > 0 && !useFlag" :goWhere="'elg'" :list="info.elgList" />
          <div v-if="info.elgList.length > 0 && !useFlag" class="rsk-align-right rsk-mb-s">
            <a href="javascript:void(0);" @click="moveToPageByPath('/elgstudy')"
              class="rsk-display_inline-flex rsk-text-primary rsk-flex rsk-items-center rsk-hover-underline">
              {{ $t("usrTopPages.adminTopAllElgPageToolip") }}
              <span class="rsk-button__icon-wrapper rsk-button__icon-wrapper--with-text">
                <span class="rsk-icon rsk-icon--carret-right-user"></span>
              </span>
            </a>
          </div>

          <rsk-panel-list v-if="info.tesList.length > 0 && !useFlag" :goWhere="'tes'" :list="info.tesList" />
          <div v-if="info.tesList.length > 0 && !useFlag" class="rsk-align-right rsk-mb-s">
            <a href="javascript:void(0);" @click="moveToPageByPath('/listen/tes')"
              class="rsk-display_inline-flex rsk-text-primary rsk-flex rsk-items-center rsk-hover-underline">
              {{ $t("usrTopPages.adminTopAllTesPageToolip") }}
              <span class="rsk-button__icon-wrapper rsk-button__icon-wrapper--with-text">
                <span class="rsk-icon rsk-icon--carret-right-user"></span>
              </span>
            </a>
          </div>
          <rsk-panel-list v-if="info.antList.length > 0 && !useFlag" :goWhere="'ant'" :list="info.antList" />
          <div v-if="info.antList.length > 0 && !useFlag" class="rsk-align-right rsk-mb-s">
            <a href="javascript:void(0);" @click="moveToPageByPath('/listen/ant')"
              class="rsk-display_inline-flex rsk-text-primary rsk-flex rsk-items-center rsk-hover-underline">
              {{ $t("usrTopPages.adminTopAllAntPageToolip") }}
              <span class="rsk-button__icon-wrapper rsk-button__icon-wrapper--with-text">
                <span class="rsk-icon rsk-icon--carret-right-user"></span>
              </span>
            </a>
          </div>
          <rsk-panel-list v-if="info.repList.length > 0 && !useFlag" :goWhere="'rep'" :list="info.repList" />
          <div v-if="info.repList.length > 0 && !useFlag" class="rsk-align-right rsk-mb-s">
            <a href="javascript:void(0);" @click="moveToPageByPath('/listen/rep')"
              class="rsk-display_inline-flex rsk-text-primary rsk-flex rsk-items-center rsk-hover-underline">
              {{ $t("usrTopPages.adminTopAllRepPageToolip") }}
              <span class="rsk-button__icon-wrapper rsk-button__icon-wrapper--with-text">
                <span class="rsk-icon rsk-icon--carret-right-user"></span>
              </span>
            </a>
          </div>

          <rsk-title-bar v-if="(info.applyElgList.length > 0 || info.traList.length > 0) && !useFlag"
            :title="$t('usrTopPages.adminTopSelfStudyTitle')" :describe="processedDescribeText" @click="handleLinkClick"/>

          <rsk-panel-list v-if="info.applyElgList.length > 0 && !useFlag" :goWhere="'elg'" :list="info.applyElgList" />
          <div v-if="info.applyElgList.length > 0 && !useFlag" class="rsk-align-right rsk-mb-s">
            <a href="javascript:void(0);" @click="moveToPageByPath('/elgstudy')"
              class="rsk-display_inline-flex rsk-text-primary rsk-flex rsk-items-center rsk-hover-underline">
              {{ $t("usrTopPages.adminTopAllElgPageToolip") }}
              <span class="rsk-button__icon-wrapper rsk-button__icon-wrapper--with-text">
                <span class="rsk-icon rsk-icon--carret-right-user"></span>
              </span>
            </a>
          </div>
          <rsk-panel-list v-if="info.traList.length > 0 && !useFlag" :goWhere="'tra'" :list="info.traList" />
          <div v-if="info.traList.length > 0 && !useFlag" class="rsk-align-right rsk-mb-s">
            <a href="javascript:void(0);" @click="moveToPageByPath('/trastudy')"
              class="rsk-display_inline-flex rsk-text-primary rsk-flex rsk-items-center rsk-hover-underline">
              {{ $t("usrTopPages.adminTopAllTraPageToolip") }}
              <span class="rsk-button__icon-wrapper rsk-button__icon-wrapper--with-text">
                <span class="rsk-icon rsk-icon--carret-right-user"></span>
              </span>
            </a>
          </div>

            <div class="rsk-flex rsk-justify-between" v-if="(info.applyElgQstList.length > 0 ) && !useFlag">
              <div class="rsk-flex">
                <span class="questionnaires-title">
                  {{ $t("usrTopPages.adminQuestionnaires") }}
                  <rsk-title-bar :title="$t('usrTopPages.adminTopAppQstTitle')" style="white-space: nowrap;"/>
                </span>
                <div style="padding: 2px">
                  <span class="rsk-icon rsk-icon--question-gray" style="position: relative; top: 25px;">
                    <label class="rsk-tooltip rsk-tooltip--250 rsk-tooltip--bottom" style="height: fit-content;right: 188px;transform: translateY(-38%);width: 400px;">
                      <span>
                        リスクモンスター株式会社（サービス提供会社）からのお願いです。今後のサービス向上のため、お客様が受講されたeラーニングについて感想をお聞かせください。
                        <br>
                        ※回答済みのアンケートは非表示になります。<br>
                        ※最大３件表示されます。<br>
                        ※受講修了後、未回答の状態で６ヶ月経過したアンケートは非表示になります。
                      </span>
                    </label>
                  </span>
                </div>
              </div>
              <rsk-title-bar :describe="processedDescribeText" @click="handleLinkClick" style="position: relative; top: 10px;"  />
            </div>


          <rsk-panel-list v-if="info.applyElgQstList.length > 0 && !useFlag" :goWhere="'elgQst'" :list="info.applyElgQstList" />

          <rsk-panel v-if="displayFlg1 && !useFlag && !isDispatchAgencyFlag">
            <template v-slot:title>
              <div class="rsk-flex rsk-items-center rsk-mb-s">
                <span class="rsk-icon rsk-icon--star-gray rsk-mr-xs"></span>
                <div class="rsk-text-gray100 rsk-font-bold rsk-font-l rsk-mr-m">{{
              $t("usrTopPages.adminTopPopularTitle1") }}</div>
              </div>
            </template>
            <template v-slot:items>
              <div class="rsk-font-bold rsk-text-gray100 rsk-mb-s">
                {{ $t("usrTopPages.adminTopPopularTitle2") }}
              </div>
              <rsk-radio :options="rskRadioList" @onChange="radioChange" class="rsk-mb-m" />
              <rsk-article-list v-if="info.hotList.length > 0" :list="info.hotList" />
              <div class="rsk-flex rsk-justify-right">
                  <a href="javascript:void(0);" @click="toElgSearchByType()"
                    class="rsk-display_inline-flex rsk-text-primary rsk-flex rsk-items-center rsk-hover-underline">
                    研修一覧へ
                    <span class="rsk-button__icon-wrapper rsk-button__icon-wrapper--with-text">
                      <span class="rsk-icon rsk-icon--carret-right-user"></span>
                    </span>
                  </a>
              </div>
              <div class="rsk-font-size-s rsk-align-left rsk-text-gray080">{{ $t("usrTopPages.adminTopPopularTitle3")
                }}</div>
              <div class="rsk-font-size-s rsk-align-left rsk-text-gray080">{{ $t("usrTopPages.adminTopPopularTitle4")
                }}</div>
              <div class="rsk-font-size-s rsk-align-left rsk-text-gray080">{{ $t("usrTopPages.adminTopPopularTitle5")
                }}</div>
            </template>
          </rsk-panel>

        </div>
      </div>
    </div>
  </div>
  <!-- <rsk-tool :type="['backtop', 'feedback']"/> -->
</template>

<script>
import { dateFtt, yyyymmddToDate } from '@/utils/common'
import { ref, inject, computed, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

export default {
  setup() {
    const router = useRouter()
    const service = inject("service");
    const { locale, t } = useI18n({ useScope: 'global' })
    locale.value = localStorage.getItem('lang') || 'ja'
    const displayFlg5 = localStorage.getItem('displayFlg5') == "true" ? true : false;
    const displayFlg1 = localStorage.getItem('displayFlg1') == "true" ? true : false;
    const displayFlg2 = localStorage.getItem('displayFlg2') == "true" ? true : false;
    const useFlag = ref(false)
    const learnTimeTitle = ref('');
    const learnTimeTooilp = ref('');
    const studyTimeUnShowFlag = ref(2)
    const chiocedType = ref(0)
    const radios = {
      '0': t('usrTopPages.adminTopPopularTypeAll'),
      '1': t('usrTopPages.adminTopPopularType1'),
      '2': t('usrTopPages.adminTopPopularType2'),
      '3': t('usrTopPages.adminTopPopularType3'),
      '4': t('usrTopPages.adminTopPopularType4'),
      '5': t('usrTopPages.adminTopPopularType5'),
      '6': t('usrTopPages.adminTopPopularType6'),
      '7': t('usrTopPages.adminTopPopularType7'),
      '8': t('usrTopPages.adminTopPopularType8'),
      '9': t('usrTopPages.adminTopPopularType9'),
      '10': t('usrTopPages.adminTopPopularType10'),
      '11': t('usrTopPages.adminTopPopularType11'),
      '12': t('usrTopPages.adminTopPopularType12'),
      '13': t('usrTopPages.adminTopPopularType13'),
      '14': t('usrTopPages.adminTopPopularType14'),
    }
    const showModal = ref(false);
    const onboardingModalFlag = ref(-1);

    localStorage.removeItem("fromTopUrl");

    const isDispatchAgencyFlag = localStorage.getItem('isDispatchAgencyFlag') == 'false' ? ref(false) : ref(true);

    const info = ref({
      loginId: '',
      loginBefEntDtm: new Date(),
      usrMlAdr: '',
      studiedElgCnt: 0,
      allStudyElgCnt: 0,
      studyElgPercen: 0,
      infList: [],
      elgList: [],
      tesList: [],
      antList: [],
      repList: [],
      lesList: [],
      applyElgList: [],
      hotList: [],
      rskRadioList: [],
      traList: [],
      applyElgQstList: [],
      bpfElgList: [],
      rmElgBenchmarkList: [],
      rmElgOnboardingList: []
    })
    service.top.getUsrTopInfo().then(res => {
      info.value.loginId = res.loginId
      info.value.loginBefEntDtm = dateFtt('yyyy/MM/dd', res.loginBefEntDtm)
      info.value.usrMlAdr = res.usrMlAdr
      info.value.studyElgPercen = res.studyElgPercen
      info.value.usrStdFlg = res.usrStdFlg;
      info.value.displayFlg7 = res.displayFlag7
      info.value.learningTimeShow = res.learningTimeShow
      if (res.useFlag && res.useFlag === 1) {
				useFlag.value = true
			} else {
				useFlag.value = false
			}
      if (info.value.displayFlg7 != studyTimeUnShowFlag.value) {
        learnTimeTitle.value = info.value.displayFlg7 == 0 ? t('usrTopPages.adminUsrTopLearnTimeBase') : t('usrTopPages.adminUsrTopLearnTimeReal')
        learnTimeTooilp.value = info.value.displayFlg7 == 0 ? t('usrTopPages.adminUsrTopLearnTimeToolipBase') : t('usrTopPages.adminUsrTopLearnTimeToolipReal')
      }
      res.infList.forEach(item => {
        info.value.infList.push({
          date: dateFtt('yyyy/MM/dd', item.iniEntDtm),
          text: item.content,
          id: item.informationId,
        })
      });

      res.elgList.forEach(item => {
        info.value.elgList.push({
          elearningId: item.elearningId,
          lessonId: item.lessonId,
          startDate: dateFtt('yyyy/MM/dd', item.jyukouStartDay),
          endDate: dateFtt('yyyy/MM/dd', item.limitDate),
          title: t('usrTopPages.adminTopElgTitle'),
          describe: item.elearningName,
          count: item.progressRate | 0,
          url: item.eLearningURL,
          startDateTitle: t('usrTopPages.adminUsrTopFromDate'),
          endDateTitle: t('usrTopPages.adminUsrTopElgLimitDate'),
          studyFlg: item.studyFlg,
          applicationDtm: item.applicationDtm,
          preconditionFlg: item.preconditionFlg,
          termOutside: item.termOutside,
          nonScormType: item.nonScormType,
          newContentFlg: item.newContentFlg
        })
      });

      res.tesList.forEach(item => {
        info.value.tesList.push({
          testId: item.testId,
          lessonId: item.lessonId,
          limitDate: dateFtt('yyyy/MM/dd', item.limitDate),
          title: t('usrTopPages.adminTopTesTitle'),
          describe: item.testName,
          count: item.progress,
          dateTitle: t('usrTopPages.adminUsrTopTestLimitDate'),
          preconditionFlg: item.preconditionFlg,
          answerFlg: item.answerFlg
        })
      });

      res.antList.forEach(item => {
        info.value.antList.push({
          anketoId: item.anketoId,
          lessonId: item.lessonId,
          limitDate: dateFtt('yyyy/MM/dd', item.limitDate),
          title: t('usrTopPages.adminTopAntTitle'),
          describe: item.anketoName,
          count: 0,
          dateTitle: t('usrTopPages.adminUsrTopAntLimitDate'),
          preconditionFlg: item.preconditionFlg
        })
      });

      res.repList.forEach(item => {
        info.value.repList.push({
          reportId: item.reportId,
          lessonId: item.lessonId,
          limitDate: dateFtt('yyyy/MM/dd', item.limitDate),
          title: t('usrTopPages.adminTopRepTitle'),
          describe: item.reportName,
          count: 0,
          dateTitle: t('usrTopPages.adminUsrTopRepLimitDate'),
          preconditionFlg: item.preconditionFlg
        })
      });

      res.lesList.forEach(item => {
        info.value.lesList.push({
          lessonId: item.lessonId,
          startDate: dateFtt('yyyy/MM/dd', item.startDate),
          endDate: dateFtt('yyyy/MM/dd', item.endDate),
          title: t('usrTopPages.adminTopBoxTitle'),
          describe: item.lessonName,
          count: 0,
          startDateTitle: t('usrTopPages.adminUsrTopFromDate'),
          endDateTitle: t('usrTopPages.adminUsrTopToDate'),
          count: (item.tourokufincount / item.tourokucount * 100).toFixed(0) | 0,
        })
      });

      res.applyElgList.forEach(item => {
        info.value.applyElgList.push({
          elearningId: item.elearningId,
          lessonId: item.lessonId,
          startDate: dateFtt('yyyy/MM/dd', item.jyukouStartDay),
          endDate: dateFtt('yyyy/MM/dd', item.limitDate),
          title: t('usrTopPages.adminTopElgTitle'),
          describe: item.elearningName,
          count: item.progressRate,
          startDateTitle: t('usrTopPages.adminUsrTopFromDate'),
          endDateTitle: t('usrTopPages.adminUsrTopElgLimitDate'),
          url: item.eLearningURL,
          studyFlg: item.studyFlg,
          applicationDtm: item.applicationDtm,
          preconditionFlg: item.preconditionFlg,
          termOutside: item.termOutside,
          nonScormType: item.nonScormType,
          newContentFlg: item.newContentFlg
        })
      });

      res.applyElgQstList.forEach(item => {
        info.value.applyElgQstList.push({
          elearningId: item.elearningId,
          describe: item.elearningName,
          title: t('usrTopPages.adminTopElgTitle'),
          url: '/ope_elgant/' + item.appQstKEY + '/edit'

        })
      });

      let index = 1;
      res.hotList.forEach(item => {
        info.value.hotList.push({
          elearningId: item.id,
          title: item.name,
          describe: !!radios[item.type] ? t('usrTopPages.adminTopPopularTitle2') + ': ' + radios[item.type] : t('usrTopPages.adminTopPopularTitle2') + ': ',
          index: index,
          rank: item.rank,
          loginRank: res.usrLoginRank,
          priceApplication: item.priceApplication,
          clickFlag: item.clickFlag
        })
        index++;
      });

      res.traList.forEach(item => {
        info.value.traList.push({
          trainId: item.trainId,
          openStartDtm: dateFtt('yyyy/MM/dd hh:mm', item.openStartDtm),
          openEndDtm: dateFtt('yyyy/MM/dd hh:mm', item.openEndDtm),
          title: t('usrTopPages.adminTopTraoTitle'),
          describe: item.trainName,
          dateTitle: t('usrTopPages.adminUsrTopTraDate'),
        })
      })
      res.bpfElgList.forEach(item => {
        info.value.bpfElgList.push({
          elearningId: item.elearningId,
          describe: item.elearningName,
          title: t('usrTopPages.adminTopElgTitle')
        })
      })
      res.rmElgBenchmarkList.forEach(item => {
          info.value.rmElgBenchmarkList.push({
              elearningId: item.elearningId,
              describe: item.elearningName,
              title: t('usrTopPages.adminTopElgTitle')
          })
      })
      res.rmElgOnboardingList.forEach(item => {
          info.value.rmElgOnboardingList.push({
              elearningId: item.elearningId,
              describe: item.elearningName,
              title: t('usrTopPages.adminTopElgTitle')
          })
      })
      if (res.onboardingModalFlag !== undefined) {
      onboardingModalFlag.value = Number(res.onboardingModalFlag);
      }

      const ver = versions.value[onboardingModalFlag.value];
      if (ver && localStorage.getItem(ver.storageKey) === 'true') {
      showModal.value = false;
      } else {
      showModal.value = true;
      }
    })

    function getHotList(type) {
      info.value.hotList = []
      service.top.getHotList(type).then(res => {
        let index = 1;
        res.hotList.forEach(item => {
          info.value.hotList.push({
            elearningId: item.id,
            title: item.name,
            describe: !!radios[item.type] ? t('usrTopPages.adminTopPopularTitle2') + ': ' + radios[item.type] : t('usrTopPages.adminTopPopularTitle2') + ': ',
            index: index,
            rank: item.rank,
            loginRank: res.usrLoginRank,
            priceApplication: item.priceApplication,
            clickFlag: item.clickFlag
          })
          index++;
        })
      })
    }

    function radioChange(type) {
      chiocedType.value = type
      getHotList(type)
    }

    function informationSelect(item, index) {
      router.push({ name: 'notification', params: { id: item.id, index } })
    }

    const rskRadioList = []
    {
      rskRadioList.push(
        { label: radios[0], value: 0 },
        { label: radios[14], value: 14 },
        { label: radios[13], value: 13 },
        { label: radios[12], value: 12 },
        { label: radios[11], value: 11 },
        { label: radios[10], value: 10 },
        { label: radios[4], value: 4 },
        { label: radios[5], value: 5 },
        { label: radios[6], value: 6 },
        { label: radios[1], value: 1 },
        { label: radios[2], value: 2 },
        { label: radios[3], value: 3 },
        { label: radios[7], value: 7 },
        { label: radios[8], value: 8 },
        { label: radios[9], value: 9 },
      )
    }

    function moveToUsrPro() {
      router.push({ path: '/usrpro' })
    }
    function moveToPageByPath(path) {
      router.push({ path: path })
    }
    function toElgSearchByType () {
      router.push({ name: 'elearning', params: {type: chiocedType.value}})
    }

    const FINISHED_FLG_ALL = ["0", "1", "2"];

    function goToTrainingManagement() {
      router.push({ name: 'elgstudy', params: { finishedFlg: FINISHED_FLG_ALL } }).then(() => {
        window.scrollTo(0, 0);
      });
    }

    const FINISHED_FLAGS = ["0", "1"];

    async function goToBox() {
      await router.push({
        name: "les",
        params: { finishedFlg: FINISHED_FLAGS },
      });
      window.scrollTo(0, 0);
    }

    const processedDescribeText = computed(() => {
      let text = t('usrTopPages.adminDescribeText');

      if(displayFlg2){
        if(text.indexOf('研修管理') > -1) {
          text = text.replace(/研修管理/g, '<span class="link-training">研修管理</span>');
        }else {
          text = text.replace(/\btraining management\b/g, '<span class="link-training">training management</span>');
        }
        if(text.indexOf('ボックス') > -1) {
          text = text.replace(/ボックス/g, '<span class="link-box">ボックス</span>');
        }else {
          text = text.replace(/\bbox\b/g, '<span class="link-box">box</span>');
        }

        return text;
      }
      return text;
    });

    function handleLinkClick(e) {
      if (e.target.closest('.link-training')) {
        goToTrainingManagement();
        return;
      }

      if (e.target.closest('.link-box')) {
        goToBox();
      }
    }

    const versions = ref([
      { show: true, dontShow: false, storageKey: 'rm9FirstUseFlag' },
      { show: true, dontShow: false, storageKey:'rm9SingleRegFlag' },
      { show: true, dontShow: false, storageKey:'rm9BulkRegFlag' }
    ]);

    onMounted(() => {
      const ver = versions.value[onboardingModalFlag.value];
        if (ver && localStorage.getItem(ver.storageKey) === 'true') {
          showModal.value = false;
        }
    });

    function handleChange(index) {
      const ver = versions.value[index];
      if (ver.dontShow) {
        localStorage.setItem(ver.storageKey, 'true');
      } else {
        localStorage.removeItem(ver.storageKey);
      }
    }

    function closeModal() {
      showModal.value = false;
    }

    const moveToMngUsrNew = () => {
      location.href = location.protocol + '//' + location.hostname
        + process.env.VUE_APP_PORT_DEFAULT_KEY + '/mng/mng_usr/new'
    }

    const moveToMngUsrCsv = () => {
          location.href = location.protocol + '//' + location.hostname
            + process.env.VUE_APP_PORT_DEFAULT_KEY + '/mng/mng_usrcsv/new'
        }

    const benPanelListRef = ref(null)
    function startMiniTest() {
      const firstItem = info.value.rmElgBenchmarkList[0]
      if (firstItem && benPanelListRef.value) {
        benPanelListRef.value.goElgApp(firstItem.elearningId)
      }
    }



    return {
      info,
      rskRadioList,
      useFlag,
      informationSelect,
      radioChange,
      moveToUsrPro,
      displayFlg5,
      displayFlg1,
      displayFlg2,
      isDispatchAgencyFlag,
      learnTimeTitle,
      learnTimeTooilp,
      studyTimeUnShowFlag,
      moveToPageByPath,
      toElgSearchByType,
      goToTrainingManagement,
      goToBox,
      processedDescribeText,
      handleLinkClick,
      onboardingModalFlag,
      versions,
      handleChange,
      showModal,
      closeModal,
      moveToMngUsrNew,
      moveToMngUsrCsv,
      benPanelListRef,
      startMiniTest
    }
  },
}
</script>

<style lang="scss" src="./css/usr_top.scss" scoped />
